module.exports = __webpack_public_path__ + "img/view-reward.9ebbcca1.png";